module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.router && _vm.router.name && _vm.type === 'item') ? _c('router-link', {
    attrs: {
      "tag": "li",
      "to": _vm.router
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "data-toggle": _vm.$root.device.isMobile ? 'push-menu' : '',
      "role": "button"
    }
  }, [_c('i', {
    class: _vm.icon
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$root.shortText(_vm.FullName, 20)))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.badge),
      expression: "badge"
    }],
    staticClass: "pull-right-container"
  }, [_c('small', {
    class: ['label pull-right', _vm.badge.type === 'String' ? 'bg-green' : 'label-primary']
  }, [_vm._v(_vm._s(_vm.badge.data))])])])]) : _c('li', {
    class: _vm.getType
  }, [(!_vm.isHeader) ? _c('router-link', {
    attrs: {
      "tag": "a",
      "to": _vm.router
    }
  }, [_c('i', {
    class: _vm.icon
  }), _vm._v(" " + _vm._s(_vm.$root.shortText(_vm.FullName, 20)) + "\n    "), _c('span', {
    staticClass: "pull-right-container"
  }, [(_vm.badge && _vm.badge.data >= 0) ? _c('small', {
    staticClass: "label pull-right label-primary"
  }, [_vm._v(_vm._s(_vm.badge.data))]) : _c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])]) : _vm._e(), _vm._v(" "), (_vm.items && _vm.items.length > 0) ? _c('ul', {
    staticClass: "treeview-menu"
  }, _vm._l((_vm.items), function(item, index) {
    return (item.router && item.router.name && item['.key'] !== 'TotalDealers') ? _c('router-link', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.show),
        expression: "item.show"
      }],
      key: index,
      attrs: {
        "tag": "li",
        "title": item.FullName,
        "data": item,
        "to": item.router
      }
    }, [_c('a', {
      attrs: {
        "data-toggle": _vm.$root.device.isMobile ? 'push-menu' : '',
        "role": "button"
      }
    }, [_c('i', {
      class: item.icon
    }), _vm._v(" " + _vm._s(_vm.$root.shortText(item.FullName, 20)) + "\n        "), _c('span', {
      staticClass: "pull-right-container"
    }, [(item.badge && item.badge.data >= 0) ? _c('small', {
      staticClass: "label pull-right bg-green"
    }, [_vm._v(_vm._s(item.badge.data))]) : _vm._e()])]), _vm._v(" "), (item.subItems && item.subItems.length > 0) ? _c('ol', {
      staticClass: "subtreeview",
      attrs: {
        "data-toggle": _vm.$root.device.isMobile ? 'push-menu' : '',
        "role": "button"
      }
    }, _vm._l((item.subItems), function(subItem, subIndex) {
      return _c('router-link', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (subItem.show),
          expression: "subItem.show"
        }],
        key: subIndex,
        attrs: {
          "tag": "li",
          "title": subItem.FullName,
          "data": subItem,
          "to": subItem.router
        }
      }, [_c('a', [_vm._v(_vm._s(_vm.$root.shortText(subItem.FullName, 20)))])])
    }), 1) : _vm._e()]) : _vm._e()
  }), 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-64ec90de!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/VASlideItem.vue
// module id = 720
// module chunks = 0